<template>
  <router-view />
</template>

<style>
body {
  background-color: #eee;
}
</style>